// extracted by mini-css-extract-plugin
module.exports = {"followMe":"kd","linkItem":"ke","linkItemWrap":"kf","title":"kg","linkAppItemWrap":"kh","iconWrap":"ki","mfollowMe":"kj","miconWrap":"kk","followMe-dark":"kl","followMeDark":"kl"};